import "./folder.css";
import cancelIcon from "./images/Cancel.png";
import folderIcon from "./images/folder.png";
import eyeIcon from "./images/Visible.png";
import penIcon from "./images/Pen.png";
import downloadIcon from "./images/DownloadFile.png";
import plusIcon from "./images/Plus.png";
import Button from "./Button/Button";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useGlobalContext } from "../../../Context/Context";

const Folder = ({
  setUpdateChecked,
  file,
  updateChecked,
  isAdding,
  deleteFile,
  addIntoFiles,
  convertBytes,
  findMemorySize,
  folderSize,
  setFiles,
  setNewFiles,
  index,
  setViewDocument,
  viewDocument,
  location,
  aspectRatio,
  location_input,
}) => {
  const btnRef = useRef();
  const { baseUrl } = useGlobalContext();
  const { apiKey, loggedUser } = useGlobalContext();
  const [addLocation,setAddLocation]= useState(false);
  const [localLocation,setLocalLocation]= useState([]);
  const [selectedLocation,setSelectedLocation] = useState();

  const handleUpdate = () => {
    setUpdateChecked((prev) => {
      // ako je fajl drugaciji i trenutno aktivan, ili ako uopste nije
      if ((prev.value && file.id !== prev.file.id) || !prev.value)
        return {
          value: true,
          file,
          isAdding,
        };
      // ako je aktivan i isti fajl
      if (prev.value && file.id === prev.file.id)
        return {
          value: false,
          file,
          isAdding,
        };
    });
  };

  const {
    id,
    uploader,
    type,
    size,
    date,
    title,
    text,
    intoEditor,
    fromEditor,
    location_id,
    data,
  } = file;

  console.log(file)

  const changeFromEditor = async () => {
    // fromEditor je bitan samo na pocetku da bude sivo
    // false false -> sivo
    // false -> crveno
    // true -> zeleno
    // treba endpoint da se doda
    console.log(location_input);
    console.log(location,intoEditor);

    if(location_input === null && !intoEditor )
    {
      try {
        axios
          .post(`${baseUrl}/location_documents/getAllLocationsByUserId.php`, {
            user_id: loggedUser.id,
            api_key: apiKey,
          })
          .then((data) => {
            console.log("Poziva se i postavlja item list", data);
            if (data.data.status === 200) {
              setLocalLocation(data.data.locations);
              setAddLocation(true);
            }
          });
        //console.log(response);
      } catch (error) {
        console.log("Error fetching messages");
      }

      
    }
    else{
    try {
      const { data } = await axios.post(
        `${baseUrl}/location_documents/updateIntoEditor.php`,
        {
          location_id: location.location_id,
          location_input: location_input === null ? location_id: location_input,
          user_id: loggedUser.id,
          api_key: apiKey,
          document_id: id,
          intoEditor: intoEditor ? 1 : 0,
          fromEditor: fromEditor ? 1 : 0,
        }
      );
      if (data.status === 200) {
        let newFile;
        if (!intoEditor && !fromEditor)
          newFile = { ...file, intoEditor: true, fromEditor: true };
        else if (!intoEditor) newFile = { ...file, intoEditor: true };
        else newFile = { ...file, intoEditor: false };
        if (isAdding) {
          setNewFiles((prev) =>
            prev.map((file) => {
              if (file.id === id) return newFile;
              else return file;
            })
          );
        } else {
          setFiles((prev) =>
            prev.map((file) => {
              if (file.id === id) return newFile;
              else return file;
            })
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  };

  const chooseLocalLocation =async (location) => {
      setSelectedLocation(location)
      setAddLocation(false);
      try {
        const { data } = await axios.post(
          `${baseUrl}/location_documents/updateIntoEditor.php`,
          {
            location_id: null,
            location_input:location.location_id,
            user_id: loggedUser.id,
            api_key: apiKey,
            document_id: id,
            intoEditor: intoEditor ? 1 : 0,
            fromEditor: fromEditor ? 1 : 0,
          }
        );
        if (data.status === 200) {
          let newFile;
          if (!intoEditor && !fromEditor)
            newFile = { ...file, intoEditor: true, fromEditor: true };
          else if (!intoEditor) newFile = { ...file, intoEditor: true };
          else newFile = { ...file, intoEditor: false };
          if (isAdding) {
            setNewFiles((prev) =>
              prev.map((file) => {
                if (file.id === id) return newFile;
                else return file;
              })
            );
          } else {
            setFiles((prev) =>
              prev.map((file) => {
                if (file.id === id) return newFile;
                else return file;
              })
            );
          }
        }
      } catch (error) {
        console.log(error);
      }
  }

  const viewDocumentContain = () => {
    console.log(file, index);
    try {
      axios
        .post(`${baseUrl}/location_documents/doc_test.php`, {
          user_id: loggedUser.id,
          location_id: location.location_id,
          api_key: apiKey,
          location_document_id: id,
        })
        .then((data) => {
          console.log("Poziva se i postavlja item list", data);
          if (data.data.status === 200) {
            console.log(data.data.data);

            setViewDocument({
              id,
              value: true,
              data: data.data.data,
              name: title,
            });
          }
        });
      //console.log(response);
    } catch (error) {
      console.log("Error fetching messages");
    }
  };

  const downloadFile = () => {
    try {
      axios
        .post(`${baseUrl}/location_documents/getDocumentData.php`, {
          user_id: loggedUser.id,
          location_id: location.location_id,
          api_key: apiKey,
          location_document_id: id,
        })
        .then((data) => {
          console.log("Poziva se i postavlja item list", data);
          if (data.data.status === 200) {
            const a = document.createElement("a");
            a.href = data.data.data;
            a.download = title;
            a.click();
          }
        });
      //console.log(response);
    } catch (error) {
      console.log("Error fetching messages");
    }
  };

  const setClassName = () => {
    let className = "left-folder-title";
    if (intoEditor) className += " correct";
    else if (!intoEditor && fromEditor) className += " wrong";
    return className;
  };

  useEffect(() => {
    if (isAdding) {
      // kad se namesti u admin panel promeni da se vadi iz local storage klasa za dugme
      const remainingMemory = folderSize - (findMemorySize() + size);
      if (remainingMemory < 0) {
        const btn = btnRef.current.querySelector(".dos-btn");
        btn.classList.add("wrong-btn");
        btnRef.current.style.pointerEvents = "none";
      }
    }
  }, []);

  return (
    <div className={aspectRatio < 1 ? "folder portrait" : "folder"}>
      {!addLocation ?
      <div
        className={aspectRatio < 1 ? "folder-header portrait" : "folder-header"}
      >
        <div
          className={
            aspectRatio < 1
              ? "folder-app-header-part portrait"
              : "folder-app-header-part"
          }
        >
          <div className="info">
            <div className="top">
              <span className="number">{index}.</span>
              {location.location_id !== null && (
                <span className="name">{uploader}</span>
              )}
              <span
                className="date"
                style={
                  location.location_id !== null
                    ? { justifyContent: "flex-end" }
                    : { justifyContent: "flex-start" }
                }
              >
                {format(date, "dd.MM.yyyy")}
              </span>
              {location.location_id === null && (
                <div className="right-admin">
                  <span className="size-admin">{convertBytes(size)}</span>
                  <span className="type-admin">{type}</span>
                </div>
              )}
            </div>
            <div className="bottom">
              <div className={setClassName()}>{title}</div>
              {location.location_id !== null ? (
                <div className="right">
                  <span className="size">{convertBytes(size)}</span>
                  <span className="type">{type}</span>
                </div>
              ) : (
                <div className="right-img-admin">
                  <span className="right-image">Slika</span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className={aspectRatio < 1 ? "folder-text portrait" : "folder-text"}
        >
          {text}
        </div>
        <div
          className={
            aspectRatio < 1
              ? "folder-app-header-part portrait"
              : "folder-app-header-part"
          }
        >
          {isAdding ? (
            <div
              className={aspectRatio < 1 ? "add-button portrait" : "add-button"}
              ref={btnRef}
              onClick={() => addIntoFiles(id)}
            >
              <Button image={plusIcon} />
            </div>
          ) : (
            <div
              className={aspectRatio < 1 ? "add-button portrait" : "add-button"}
              onClick={downloadFile}
            >
              <Button activation={true} image={downloadIcon} />
            </div>
          )}

          <div
            className={aspectRatio < 1 ? "add-button portrait" : "add-button"}
            onClick={handleUpdate}
          >
            <Button
              active={updateChecked.value && updateChecked.file.id === id}
              image={penIcon}
            />
          </div>
          <div
            className={aspectRatio < 1 ? "add-button portrait" : "add-button"}
            onClick={viewDocumentContain}
          >
            <Button active={viewDocument.value} image={eyeIcon} />
          </div>
          <div
            className={aspectRatio < 1 ? "add-button portrait" : "add-button"}
            onClick={changeFromEditor}
          >
            <Button active={intoEditor} image={folderIcon} />
          </div>
          <div
            className={aspectRatio < 1 ? "add-button portrait" : "add-button"}
            onClick={() => deleteFile(id, isAdding)}
          >
            <Button image={cancelIcon} />
          </div>
        </div>
      </div>
      :
      <div className="wrapper-location-local">
        {
          localLocation.map((location)=>{
            return <div className="location-list-folder"><div
            className="add-button"
            onClick={()=> chooseLocalLocation(location)}
          >
            <Button activation={true}><span className="location-list-button">{location.location_name}</span> </Button>
          </div></div>
          })
        }
      </div>
      }
    </div>
  );
};

export default Folder;
